export default [
    { text: '#', value: 'id' },
    { text: 'Cliente', value: 'customerName' },
    { text: 'Sucursal Cliente', value: 'customerBranchOfficeName' },
    { text: 'Fecha Creación', value: 'creationDateString' },
    { text: 'Plazo Pago', value: 'pchPaymentConditionText' },
    { text: 'Estado', value: 'gStateText' },
    { text: 'Armado Por', value: 'armerUserName' },
    { text: 'Fecha Armado', value: 'armedDate' },
    { text: 'Hora Armado', value: 'armedTime' },
    { text: 'Acciones', value: 'slot' },
]
